/**
 * Licensed Materials - Property of IBM
 * IBM Watson (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FakeVisualizationPreview from './FakeVisualizationPreview';
import classnames from 'classnames';

import './visPreviewList.scss';
import './fakeVisPreviewList.scss';

class FakeVisualizationPreviewList extends Component {

	render() {
		const classNames = classnames({
			'vis-recommender__preview-list vis-recommender__preview-list--horizontal': this.props.horizontal,
			'vis-recommender__preview-list vis-recommender__preview-list--vertical': !this.props.horizontal
		});
		const itemsClassNames = classnames({
			'vis-recommender__preview-list--horizontal__items': this.props.horizontal,
			'vis-recommender__preview-list--vertical__items': !this.props.horizontal
		});

		return (
			<div className={classNames}>
				<div className={itemsClassNames}>
					{this.renderListItems()}
				</div>
				<div className='vis-recommender__preview-list__fake-see-more'/>
			</div>
		);
	}

	renderListItems() {
		const listItems = [];
		for(let i = 0; i < this.props.numberOfItems; i++) {
			listItems.push(
				<FakeVisualizationPreview
					horizontal={this.props.horizontal}
					key={i}
					isNewLayout={this.props.isNewLayout}
					showTextPending={this.props.showTextPending}
					size={this.props.itemSize}
				/>
			);
		}
		return listItems;
	}
}

FakeVisualizationPreviewList.propTypes = {
	horizontal: PropTypes.bool,
	numberOfItems: PropTypes.number,
	showTextPending: PropTypes.bool,
	isNewLayout: PropTypes.bool,
	itemSize: PropTypes.oneOf(['small', 'medium', 'large'])
};

FakeVisualizationPreviewList.defaultProps = {
	horizontal: false
};

export default FakeVisualizationPreviewList;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-recommender/src/js/preview/FakeVisualizationPreviewList.js